/** @jsx jsx */
import { SingleSelect, SingleSelectProps } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { withFormikField } from "@/components/Formik";
import { TimeReportProject } from "@/data/time-reports";

interface TimeReportProjectSingleSelectProps {
  options: TimeReportProject[];
  name?: string;
  value?: TimeReportProject;
  onChange?: (value?: TimeReportProject) => void;
  size?: SingleSelectProps["size"];
  placeholder?: string;
  disabled?: boolean;
}

export const TimeReportProjectSingleSelect: FC<TimeReportProjectSingleSelectProps> = ({
  options,
  name,
  value,
  onChange,
  disabled,
  ...selectProps
}) => {
  const { t } = useTranslation("session");

  return (
    <SingleSelect<TimeReportProject>
      options={options}
      ariaOptionsLabel={t("TIME_REPORTS.DETAILS.SELECT_PROJECT")}
      // @ts-ignore
      name={name}
      value={value}
      labelSelector={p => p.projectName}
      identifierSelector={p => p.project.guid}
      onChange={onChange}
      disabled={disabled}
      {...selectProps}
    />
  );
};

export const FormikTimeReportProjectSingleSelect = withFormikField(TimeReportProjectSingleSelect);
